import React from "react";
import { Controller } from "react-hook-form";
import Dropdown from "../Dropdown/Dropdown";

const ScriptForm = ({ control, errors, showAdvanced, setShowAdvanced, llmOptions = [] }) => {
  return (
    <div className="wizard-step-content">
      <h3 className="step-title">Script & Conversation Flow</h3>
      <p className="step-subtitle">Define the initial message and call flow</p>

      <div className="cw-form-field">
        <label className="cw-form-label">Initial Message / Greeting</label>
        <Controller
          name="initial_message"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              className="cw-form-textarea"
              placeholder="Enter the greeting message your bot will use..."
              rows={4}
            />
          )}
        />
        {errors.initial_message && (
          <span className="cw-error-text">{errors.initial_message.message}</span>
        )}
      </div>

      <div className="cw-form-field" style={{ marginTop: 20 }}>
        <label className="cw-form-label">Call Flow Script / System Prompt</label>
        <Controller
          name="call_flow_script"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              className="cw-form-textarea"
              placeholder="Enter the complete conversation flow and instructions for the bot..."
              rows={8}
            />
          )}
        />
        {errors.call_flow_script && (
          <span className="cw-error-text">{errors.call_flow_script.message}</span>
        )}
      </div>

      {/* Advanced Settings Toggle */}
      <div className="advanced-settings-section" style={{ marginTop: 30 }}>
        <button
          type="button"
          className="advanced-toggle-btn"
          onClick={() => setShowAdvanced(!showAdvanced)}
        >
          {showAdvanced ? "Hide" : "Show"} Advanced Settings
        </button>

        {showAdvanced && (
          <div className="advanced-settings-content">
            <div className="cw-form-grid-2">
              <div className="cw-form-field">
                <label className="cw-form-label">Timeout (seconds)</label>
                <Controller
                  name="timeout"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="number"
                      className="cw-form-input"
                      min={10}
                      max={300}
                    />
                  )}
                />
                {errors.timeout && (
                  <span className="cw-error-text">{errors.timeout.message}</span>
                )}
              </div>

              <div className="cw-form-field">
                <label className="cw-form-label">AI Model</label>
                <Controller
                  name="ai_model"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Dropdown
                      name="ai_model"
                      value={value}
                      onChange={(e) => onChange(e.target.value)}
                      options={llmOptions}
                      placeholder="Select AI Model"
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScriptForm;
